import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><span
                                                className="heading"><img className="heading_image"
                                                                         src={require('@images/greendot.jpg')}/></span><span
                                                className="heading">SIMPLE TECHNIQUES FOR CONSTRUCTIVE CHALLENGE</span>
                                            </div>
                                            <div className="border_subtitle">Own your feelings</div>
                                            <p>Instead of making assumptions and talking about what someone
                                                else thinks or intends (which
                                                you may never fully appreciate), speak from your own
                                                perspective and describe your own feelings. This allows the
                                                other person to recognise how his or her behaviour is
                                                interpreted by you and, possibly, others. For example,
                                                instead of: <span className="subtiltereg">'You upset me when you don't listen'</span> try <span
                                                    className="subtiltereg">'when you talk over me, it makes me think you're not listening and I feel upset'.</span> The
                                                first explanation 'blames'
                                                whereas the second 'explains'. </p>

                                            <div className="border_subtitle">Describe the behaviour, not the
                                                person
                                            </div>
                                            <p>If someone thinks you're criticising them as a person,
                                                they're likely to react negatively. Instead,
                                                describe the specific behaviour you're challenging because
                                                this is something that can be modified or changed. Instead
                                                of: <span
                                                    className="subtiltereg">'You are aggressive and rude'</span> try <span
                                                    className="subtiltereg">'when you point at people and tell them they are wrong, it comes across as aggressive and could be perceived as rude'.</span> This
                                                is about recognising that there can be a difference between
                                                someone's intention, and how others interpret their
                                                behaviour. </p>

                                            <div className="border_subtitle">Be specific</div>
                                            <p>Decide exactly what it is you want or feel and communicate it
                                                clearly and brieﬂy. That doesn't
                                                mean being perfunctory and rude - just don't chew on it and
                                                make it even more of an issue. </p>

                                            <div className="border_subtitle">Repeat important messages</div>
                                            <p>Repeat your clear, specific statement until the other person
                                                has heard and responded. This is
                                                particularly useful if you're feeling nervous, or dealing
                                                with someone who is manipulative or
                                                aggressive. It can also avoid getting tangled up in
                                                arguments and justifications. </p>

                                            <div className="border_subtitle">Acknowledge and field
                                                responses
                                            </div>
                                            <p>To show that you've heard what someone has said to you, it's
                                                important to acknowledge it. All you
                                                need to do is repeat it without making any comment, then
                                                repeat your own statement, e.g. <span
                                                    className="subtiltereg"> 'I understand
    that it will mean changing the holiday rotas because I want to take my holiday in July this year.'</span></p>

                                            <div className="border_subtitle">Find a workable compromise
                                            </div>
                                            <p>When there is a genuine conﬂict of interest, there doesn't
                                                have to be a 'winner' and a 'loser'. If you
                                                treat each other as equal and consider each other's needs,
                                                you should both get enough of
                                                whatever it is you want, to feel able to give something back
                                                without feeling resentful! </p>

                                            <div className="border_subtitle">Self disclose</div>
                                            <p>Sometimes we might want and intend to be assertive, but get
                                                'hijacked' by our emotions. Just say
                                                how you feel, simply and in a clear, direct way (we call
                                                this 'self-disclosure'). </p>

                                            <div className="border_subtitle">Use negative assertion</div>
                                            <p>This is a useful way to deal with criticism. Usually, we deny
                                                whatever it is and become defensive
                                                or shirty! We can diffuse negativity for both parties,
                                                however, by simply acknowledging the criticism and offering
                                                to adapt our behaviour in a given situation: <span
                                                    className="subtiltereg"> 'Yes, I am impulsive. That's my
    natural way, will it cause us any problems?'</span></p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}